import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { api } from "api";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes";
import { prepareErrorMessage } from "helpers/prepareErrorMessage";
import { errorSnack, loadingSnack, successSnack } from "helpers/message";

export const useLogout = () => {
  const { t } = useTranslation();
  const [logOut] = api.endpoints.logout.useMutation();
  const navigate = useNavigate();

  return useCallback(() => {
    loadingSnack({
      content: t("processing.signingOut"),
      duration: 0,
      key: "log-out",
    });

    const token = JSON.parse(localStorage.getItem("auth_token"));
    if (token) {
      logOut()
        .unwrap()
        .then(() => {
          successSnack({
            content: t("success.signedOut"),
            duration: 3,
            key: "log-out",
          });
        })
        .catch((error) => {
          const content =
            prepareErrorMessage(error) ?? t("error.somethingWentWrong");

          errorSnack({
            content,
            duration: 3,
            key: "log-out",
          });
        })
        .finally(() => {
          localStorage.clear();
          window.location.pathname = "/";
        });
    } else {
      navigate(routes.signIn.getURL());
      errorSnack({
        content: t("error.youNotAuthenticated"),
        duration: 10,
        key: "log-out",
      });
    }
  }, [logOut, navigate, t]);
};
